import { getActivityPreset } from '@interactive-room/catalog/activityPresets';
import { getSubjectById } from './constants/subjectCatalog';
import { getActivityDraft } from './activityStorage';

export interface StudioLaunchOptions {
  draftId?: string;
  launchSubjectId?: string;
  launchPresetId?: string;
}

export function resolveStudioLaunchDefaults<T>(
  emptyPayload: () => T,
  options: StudioLaunchOptions,
): { payload: T; subjectTag: string } {
  const { draftId, launchSubjectId, launchPresetId } = options;

  if (draftId) {
    const draft = getActivityDraft(draftId);
    return {
      payload: (draft?.payload as T) ?? emptyPayload(),
      subjectTag: draft?.subjectTag?.trim() || 'general',
    };
  }

  if (launchPresetId) {
    const preset = getActivityPreset(launchPresetId);
    if (preset) {
      return {
        payload: preset.payload() as T,
        subjectTag: preset.subjectTag,
      };
    }
  }

  const subjectTag = launchSubjectId
    ? (getSubjectById(launchSubjectId)?.tag ?? launchSubjectId)
    : 'general';

  return { payload: emptyPayload(), subjectTag };
}
